{
  "search.page.description": "Find account-owned records across every workspace, then open the canonical source.",
  "search.page.emptyDescription": "Enter a word or phrase; filters are optional.",
  "search.page.emptyTitle": "Search your records",
  "search.page.error": "Search results could not be loaded",
  "search.page.filterKinds": "Record types",
  "search.page.loadMore": "Load more results",
  "search.page.noResults": "No matching records",
  "search.page.noResultsHint": "Try fewer filters or a different phrase.",
  "search.page.query": "Search phrase",
  "search.page.resultCount_one": "1 result",
  "search.page.resultCount_other": "{{count}} results",
  "search.page.submit": "Search",
  "search.page.title": "Search",
  "search.kind.intakeProposal": "Intake proposal",
  "search.kind.journalEntry": "Journal entry",
  "search.kind.lifeView": "Life view",
  "search.kind.memoryCollection": "Memory collection",
  "search.kind.metricDefinition": "Metric definition",
  "search.kind.planDeviation": "Plan deviation",
  "search.kind.rationale": "Rationale",
  "search.kind.ruleDefinition": "Rule definition",
  "search.kind.scheduleBlock": "Schedule block",
  "search.kind.supportSession": "Support session",
  "search.kind.workSession": "Work session"
}
